'use strict';

import Messaging from './messaging.service.js';
import Organization from './organization.service.js';
import Devices from './devices.service.js';
import Locations from './locations.service.js';
import Monitoring from './monitoring.service.js';
import Rules from './rules.service.js';
import Subscriptions from './subscriptions.service.js';
import Users from './users.service.js';
import Auth from './auth.service.js';
import CloudConfig from './cloudConfig.service.js';
import Tags from './tags.service.js';
import Challenges from './challenges.service.js';
import Reports from './reports.service.js';
import Bots from './bots.service.js';
import Stories from './stories.service.js';
import Files from './files.service.js';
import Questions from './questions.service.js';
import Firmware from './firmware.service.js';
import Billing from './billing.service.js';
import Notification from './notification.service.js';

export default angular
  .module('maestro.services.data', [
    Messaging,
    Organization,
    Devices,
    Locations,
    Monitoring,
    Rules,
    Subscriptions,
    Users,
    Auth,
    CloudConfig,
    Tags,
    Challenges,
    Reports,
    Bots,
    Stories,
    Files,
    Questions,
    Firmware,
    Billing,
    Notification,
  ])
  .name;
